import { COMMON_DOCUMENTS } from './documents';
export const SA = {
    code: 'SA',
    name: 'Saudi Arabia',
    profileVersion: 1,
    readiness: 'ready',
    timezone: 'Asia/Riyadh',
    weekend: [5, 6],
    firstDayOfWeek: 0,
    currency: { code: 'SAR', displayFractionDigits: 2, roundToWholeUnits: false },
    subdivisions: [],
    branchSubdivision: 'none',
    locales: {
        ui: ['en', 'ar'],
        defaultUi: 'en',
        documentSecondary: 'ar',
        secondaryOnTaxDocuments: 'mandatory',
        secondaryOnClinicalDocuments: 'patient_copy',
        formatting: { en: 'en-GB', ar: 'ar-SA-u-ca-gregory-nu-latn' },
    },
    phone: { callingCode: '966', trunkPrefix: '0', nationalLengths: [9], mobilePattern: '^5\\d{8}$', example: '0501234567' },
    names: {
        parts: ['first', 'father', 'middle', 'last'],
        labels: { father: 'Father name', middle: 'Grandfather name' },
        askLocalName: true,
    },
    identity: {
        documents: [
            {
                type: 'sa_nid',
                labelKey: 'identity.sa_nid',
                label: 'National ID',
                pattern: '^1\\d{9}$',
                normalise: 'digits',
                checksum: 'luhn',
                onChecksumFail: 'refuse',
                onPatternFail: 'refuse',
                impliesNationality: 'SA',
                nphiesSystemKey: 'nationalId',
                example: '1XXXXXXXXX',
            },
            {
                type: 'sa_iqama',
                labelKey: 'identity.sa_iqama',
                label: 'Iqama',
                pattern: '^2\\d{9}$',
                normalise: 'digits',
                checksum: 'luhn',
                onChecksumFail: 'refuse',
                onPatternFail: 'refuse',
                nphiesSystemKey: 'iqama',
                example: '2XXXXXXXXX',
            },
            {
                type: 'sa_border',
                labelKey: 'identity.sa_border',
                label: 'Border number',
                pattern: '^[34]\\d{9}$',
                normalise: 'digits',
                checksum: 'luhn',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                nphiesSystemKey: 'borderNumber',
                example: '3XXXXXXXXX',
            },
            {
                type: 'sa_visa',
                labelKey: 'identity.sa_visa',
                label: 'Visa number',
                pattern: '^\\d{10}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                nphiesSystemKey: 'visa',
                example: '6XXXXXXXXX',
            },
            {
                type: 'gcc_id',
                labelKey: 'identity.gcc_id',
                label: 'GCC national ID',
                pattern: '^[0-9A-Z]{6,15}$',
                normalise: 'upper_alnum',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                needsIssuingCountry: true,
                nphiesSystemKey: 'gccId',
                example: '784XXXXXXXXXXXX',
            },
            ...COMMON_DOCUMENTS,
        ],
        defaultType: 'sa_nid',
        autoDetect: true,
        capture: { hospital: 'optional', lab: 'optional', pharmacy: 'optional' },
        askNationality: true,
        dobCalendars: ['gregory', 'islamic-umalqura'],
    },
    practitionerRegistries: [{ code: 'SCFHS', label: 'SCFHS registration' }],
    tax: [
        {
            code: 'sa_zatca',
            effectiveFrom: '2018-01-01',
            registration: { labelKey: 'tax.sa_vat', label: 'VAT number', pattern: '^3\\d{13}3$', checksum: 'none', onFail: 'warn' },
            companyRegistrationLabelKey: 'tax.sa_cr',
            companyRegistrationLabel: 'CR No.',
            standardRatePct: 15,
            serviceDefaultCategory: 'standard',
            productDefaultCategory: 'standard',
            qr: 'zatca_tlv',
            citizenRelief: { idType: 'sa_nid', category: 'zero', reason: 'sa_citizen_healthcare' },
        },
    ],
    eInvoicing: { scheme: 'zatca_p2', mandatory: 'now', fromDate: null, appliesTo: ['hospital', 'lab', 'pharmacy'] },
    payerTaxInvoiceRequired: true,
    addOns: [
        { code: 'nphies', built: true },
        { code: 'wasfaty', built: true },
        { code: 'zatca_p2', built: false },
    ],
    feeSplittingDefault: false,
};
//# sourceMappingURL=sa.js.map